// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GxHFS","rightAdornment":"Header_rightAdornment__2hAQD"};